if (typeof leh_click_pitch !== 'undefined' && leh_click_pitch) {
    (function () {
        const __LEH_firstclick = (typeof leh_first_click !== 'undefined') ? leh_first_click : false;
        const __LEH_hostname = window.location.hostname;
        const __LEH_preserved_consolelog = console.log.bind(console);
        const __LEH_urlParams = new URLSearchParams(window.location.search);
        let __LEH_oldCookie = {};
        const __LEH_cookieMap = { 'cd': null, 'cpn': null, 'src': null, 'u': null, 't1': null, 't2': null, 't3': null, 't4': null, 't5': null, 'acv': null, 'r': null, 'ref': null, 'host': null, 'utms': null };
        let __LEH_newClick = false;

        Object.keys(__LEH_cookieMap).forEach(function(key) {
            if (__LEH_getCookie('leh_' + key)) {
                if (key === 'r') {
                    return;
                }
                __LEH_oldCookie[key] = __LEH_getCookie('leh_' + key);
            }
        });

        let incomingUid = null;
        let incomingUtms = null;

        let __LEH_shop = window.location.href.match(/\?(\d+)/);
        if (__LEH_shop && __LEH_shop[1]) {
            incomingUid = __LEH_shop[1];
        }

        let utmValues = {};
        for (let [key, val] of __LEH_urlParams.entries()) {
            if (key.toLowerCase().substring(0, 4) === 'utm_' && val) {
                utmValues[key.toLowerCase()] = val;
            }
        }

        if (Object.keys(utmValues).length > 0) {
            incomingUtms = JSON.stringify(utmValues);

            if (utmValues['utm_source'] && utmValues['utm_source'].toLowerCase() === 'google') {
                if (utmValues['utm_campaign_type']) {
                    switch (utmValues['utm_campaign_type'].toLowerCase()) {
                        case 'shopping':
                            incomingUid = "498032";
                            break;
                        case 'pmax':
                            incomingUid = "994341";
                            break;
                        case 'search':
                            incomingUid = "297282";
                            break;
                    }
                }
            }
        }

        let __LEH_legacyPathMatch = window.location.pathname.match(/\/ct\/([0-9]+)/i);
        if (__LEH_legacyPathMatch && __LEH_legacyPathMatch[1]) {
            incomingUid = __LEH_legacyPathMatch[1];
            __LEH_newClick = true; 
        }

        if (window.location.search.length > 1 || (__LEH_urlParams && Array.from(__LEH_urlParams).length > 0)) {
            let urlU = __LEH_urlParams.get('u') || __LEH_urlParams.get('unc');
            if (urlU) {
                incomingUid = urlU;
                if (__LEH_urlParams.get('nc') != 1) {
                    __LEH_newClick = true;
                }
            }
        }

        let incomingT1 = null;
        if (__LEH_urlParams.get('t')) {
            incomingT1 = __LEH_urlParams.get('t');
        } else {
            incomingT1 = __LEH_urlParams.get('t1');
        }
        let incomingT2  = __LEH_urlParams.get('t2') || null;
        let incomingT3  = __LEH_urlParams.get('t3') || null;
        let incomingT4  = __LEH_urlParams.get('t4') || null;
        let incomingT5  = __LEH_urlParams.get('t5') || null;
        let incomingAcv = __LEH_urlParams.get('acv') || null;
        let incomingR   = __LEH_urlParams.get('r') || null;
        let incomingCd  = __LEH_urlParams.get('cd') || null;
        let incomingCpn = __LEH_urlParams.get('cpn') || null;
        let incomingSrc = __LEH_urlParams.get('src') || null;

        // Handle CD param(s)
        let resolvedCd = __LEH_oldCookie.cd || null;
        if (incomingCd && __LEH_isValidCampaign(incomingCd)) {
            let currentCampaigns = resolvedCd ? resolvedCd.split('|').filter(Boolean) : [];
            let exists = currentCampaigns.some(function(item) {
                return item.toLowerCase() === incomingCd.toLowerCase();
            });
            if (!exists) {
                currentCampaigns.push(incomingCd);
                resolvedCd = currentCampaigns.join('|');
            }
            __LEH_setCookie('leh_cd', resolvedCd, 30);
        }

        let shouldWriteCookies = false;
        let isDifferentAffiliate = (__LEH_oldCookie.u && incomingUid && __LEH_oldCookie.u !== incomingUid);

        if (!__LEH_firstclick) {
            // LAST CLICK MODE
            shouldWriteCookies = true;
            
            if (incomingUid && !incomingUtms) {
                __LEH_setCookie('leh_utms', "", -1);
            }
            if (incomingUtms) {
                __LEH_setCookie('leh_utms', incomingUtms, 30);
            }

            if (isDifferentAffiliate) {
                const trackingKeys = ['t1', 't2', 't3', 't4', 't5', 'acv', 'r'];
                trackingKeys.forEach(function(key) {
                    __LEH_setCookie('leh_' + key, "", -1);
                    __LEH_oldCookie[key] = null;
                });
            }
        } else {
            // FIRST CLICK MODE
            if (incomingUtms && !(__LEH_oldCookie.u)) {
                __LEH_setCookie('leh_utms', incomingUtms, 30);
            }

            if (!__LEH_oldCookie.u) {
                // Write + Freeze
                shouldWriteCookies = true;
            } else {
                // Freeze
                shouldWriteCookies = false;
            }
        }

        if (shouldWriteCookies && incomingUid) {
            __LEH_setCookie('leh_u', incomingUid, 30);
            __LEH_setCookie('leh_t1', incomingT1 || "", incomingT1 ? 30 : -1);
            __LEH_setCookie('leh_t2', incomingT2 || "", incomingT2 ? 30 : -1);
            __LEH_setCookie('leh_t3', incomingT3 || "", incomingT3 ? 30 : -1);
            __LEH_setCookie('leh_t4', incomingT4 || "", incomingT4 ? 30 : -1);
            __LEH_setCookie('leh_t5', incomingT5 || "", incomingT5 ? 30 : -1);
            __LEH_setCookie('leh_acv', incomingAcv || "", incomingAcv ? 30 : -1);
            __LEH_setCookie('leh_r', incomingR || "", incomingR ? 30 : -1);
        }

        // Always update background campaign/promo utility tags if present
        if (incomingCpn) { __LEH_setCookie('leh_cpn', incomingCpn, 30); }
        if (incomingSrc) { __LEH_setCookie('leh_src', incomingSrc, 30); }

        // Compile pitch object
        let __LEH_clickObj = {
            u: incomingUid || __LEH_oldCookie.u,
            t1: __LEH_newClick ? incomingT1 : (__LEH_oldCookie.t1 || null),
            t2: __LEH_newClick ? incomingT2 : (__LEH_oldCookie.t2 || null),
            t3: __LEH_newClick ? incomingT3 : (__LEH_oldCookie.t3 || null),
            t4: __LEH_newClick ? incomingT4 : (__LEH_oldCookie.t4 || null),
            t5: __LEH_newClick ? incomingT5 : (__LEH_oldCookie.t5 || null),
            acv: __LEH_newClick ? incomingAcv : (__LEH_oldCookie.acv || null),
            r: __LEH_newClick ? incomingR : (__LEH_oldCookie.r || null),
            cd: resolvedCd,
            src: incomingSrc || __LEH_oldCookie.src || null,
            host: __LEH_oldCookie.host || __LEH_hostname,
            ref: document.referrer,
            is_unique: true
        };

        if (__LEH_clickObj.src === 'cpe' || __LEH_clickObj.src === 'cp' || __LEH_clickObj.src === 'rebill') {
            if (__LEH_urlParams.get('hostid')) {
                __LEH_clickObj.host = __LEH_urlParams.get('hostid');
            }
        }

        if (__LEH_firstclick && __LEH_oldCookie.host) {
            __LEH_clickObj.host = __LEH_oldCookie.host;
        } else if (!__LEH_oldCookie.host) {
            __LEH_setCookie('leh_host', __LEH_clickObj.host, 30);
        }
        
        if (__LEH_clickObj.u && __LEH_oldCookie.u && __LEH_oldCookie.u === __LEH_clickObj.u) {
            __LEH_clickObj.is_unique = false;
        }

        if (__LEH_clickObj.host) {
            __LEH_clickObj.host = __LEH_clickObj.host.replace(/^www\./i, '');
        }

        __LEH_clickObj.url = window.location.href;
        
        let targetRapUid = incomingUid;
        if (targetRapUid) {
            let cleanUid = String(targetRapUid).trim();
            let isClean = (cleanUid === String(Number(cleanUid)) && !isNaN(cleanUid));

            if (isClean) {
                let existingRap = __LEH_getCookie('leh_rap') || '';
                let rapArray = existingRap.split(':').filter(Boolean);
                rapArray.unshift(cleanUid);
                rapArray = rapArray.filter(function(item) {
                    return item === String(Number(item)) && !isNaN(item);
                });
                
                let optimizedRapArray = rapArray.slice(0, 5);
                let finalizedRapString = optimizedRapArray.join(':');
                __LEH_setCookie('leh_rap', finalizedRapString, 30);
                __LEH_clickObj.rap = finalizedRapString;
            }
        }

        if (__LEH_newClick) {
            __LEH_pitchClick(__LEH_clickObj);
        } else if (__LEH_urlParams.get('r')) {
            __LEH_pitchRedirectOnly(__LEH_urlParams.get('r'), __LEH_clickObj);
        }

        // =====================
        // HELPER FUNCTIONS     
        // =====================
        function __LEH_isValidCampaign(campaign) {
            if (!campaign || !campaign.match(/^[a-zA-Z0-9_\-|]*$/)) {
                return false;
            }
            if (campaign.length > 255) {
                return false;
            }
            return true;
        }

        function __LEH_pitchClick(obj) {
            if (__LEH_urlParams.get('unc')) { obj.nc = 1; }
            fetch('https://cc.sllhlth.com/a/c', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(obj)
            })
                .then(response => response.json())
                .then((data) => {
                    if (data['message'] && data['message'] == 'banned') {
                        window.location.replace('/');
                    } else if (data['r']) {
                        let destination = data['r'].trim();
                        if (!destination.match(/^https?:\/\//i)) {
                            destination = 'https://' + destination.replace(/^\/\/+/, '');
                        }
                        window.location.replace(destination);
                    } else {
                        __LEHConsoleLog('SH Click Recorded: ' + data['message']);
                    }
                })
                .catch(function () {
                    if (__LEH_clickObj && __LEH_urlParams.get('r')) {
                        __LEH_pitchRedirectOnly(__LEH_urlParams.get('r'), __LEH_clickObj);
                    }
                });
        }

        function __LEH_pitchRedirectOnly(r, obj) {
            if (r) { obj.r = r; }
            fetch('https://cc.sllhlth.com/a/r', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(obj)
            })
                .then(response => response.json())
                .then((data) => {
                    if (data['r']) {
                        let destination = data['r'].trim();
                        if (!destination.match(/^https?:\/\//i)) {
                            destination = 'https://' + destination.replace(/^\/\/+/, '');
                        }
                        window.location.replace(destination);
                    }
                })
                .catch(function (err) { });
        }
        
        function __LEH_setCookie(name, value, days) { 
            var expires = ""; 
            if (days) { 
                var date = new Date(); 
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); 
                expires = "; expires=" + date.toUTCString(); 
            } 
            document.cookie = name + "=" + (value !== null && value !== undefined ? encodeURIComponent(value) : "") + expires + "; path=/; secure; SameSite=Lax"; 
        }
        
        function __LEH_getCookie(name) { var nameEQ = name + "="; var ca = document.cookie.split(';'); for (var i = 0; i < ca.length; i++) { var c = ca[i]; while (c.charAt(0) == ' ') c = c.substring(1, c.length); if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length, c.length)); } return null; }
        
        function __LEHConsoleLog(msg) {
            switch (typeof (msg)) {
                case 'string':
                    __LEH_preserved_consolelog('%c[LEH]: ' + msg, 'display: inline-block;font-size: 14px;background: linear-gradient(to right,rgb(255, 153, 0),rgb(204, 93, 208),rgb(44, 33, 197));color: white;padding: 4px;border-radius: 4px;');
                    break;
                default:
                    __LEH_preserved_consolelog(msg);
            }
        }
    })();
}

$ = jQuery;

// Default the cookie expiration at 5 years
const FIVE_YEARS_IN_DAYS = 1825;
let _wordplug = {
    call:           leh_call,
    called:         false,
    callQs:         '',
    callData:       {},
    cart:           {},
    country:        {},
    tags:           {},
    pc:             {},
}

document.addEventListener('DOMContentLoaded', function () {
    $.rnd = function(m,n) {
        m = parseInt(m);
        n = parseInt(n);

        return Math.floor( Math.random() * (n - m + 1) ) + m;
    }

    if (
        window.location.pathname === '/' ||
        $('.alt-promo-banner').length > 0 ||
        $('.geoipPhoneLabel').length > 0 ||
        $('.promo-banner').length > 0 ||
        $('*[usdprice]').length > 0 ||
        $('#cartBlock').length > 0 ||
        $('*[price]').length > 0 
    ) {
        leh_prep();
    }
    
    if (
        window.location.pathname === '/cart' ||
        window.location.pathname === '/cart/' ||
        $('.cartPage').length > 0
    ) {
        leh_updateCallQs('getc', '1');
    } else {
        googleShop();
    }

    if (leh_var('cpn')) {
        leh_updateCallQs('c', '1');
    }

    leh_updateGeoIpPhoneNumbers();
    leh_setupPromoCode();
    leh_setupCartIcon();

    // Run currency displays on first load of checkout pages.
    let cur = leh_var('cur');
    if (cur) {
        if ($('.packageLink').length && $('.packageButton').length ) {
            updateOrderLinks(cur);
            priceConverter(cur);
        }
    }

    $('.currency-selector, .currencySelect, .currency-selector > select').on('change', function () {
        priceConverter($(this).find(":selected").val());
        checkSezzle();
        roundPrices();
        toggleHdpSwitch();
        $('.currency-code-after').html(leh_var('cur').toUpperCase());
    });
    

    if (_wordplug.callQs.length) {
        _wordplug.call().then(function() {
            if (Object.keys(_wordplug.cart).length > 0) {
                if (typeof leh_loadCart === 'function') {
                    leh_loadCart(_wordplug.cart);
                }
            }
            toggleHdpSwitch();
            roundPrices();
        });
    }
    
    $('.hdp-toggle-switch').on('click', function(e) {
        let isActive    = $(this).hasClass('active');
        let priceEl     = $('.leh_price[qty="1"]');
        let orderButton = $('.wordplugHdpOrderButton');
        let showCents   = $(this).data('showcents') !== undefined ? $(this).data('showcents') : false;

        if (isActive) {
            let hdpPrice = orderButton.attr('data-hdpprice');
            animateNumber(
                priceEl, 
                priceEl.attr('usdprice'), 
                2000, 
                easeInOutQuad, 
                hdpPrice, 
                false,
                showCents
            );

            $('.wordplugHdpExtra').addClass('d-none');
            orderButton.text('Buy Now');
            orderButton.attr('href', orderButton.attr('data-order'));
            $('.hdp-toggle-switch').not(this).each(function() {
                $(this).removeClass('active'); 
                $(this).attr('aria-pressed', false);
            });
        } else {
            $('.wordplugHdpExtra').removeClass('d-none');
            orderButton.text('Subscribe');
            orderButton.attr('href', orderButton.attr('data-hdp'));
            orderButton.attr('data-hdpprice');
            animateNumber(
                priceEl,
                orderButton.attr('data-hdpprice'), 
                2000, 
                easeInOutQuad, 
                false,
                false,
                showCents
            );
            $('.hdp-toggle-switch').not(this).each(function() {
                $(this).addClass('active'); 
                $(this).attr('aria-pressed', true);
            });
        }
    });

    // Handle Shopify/away-links
    if ($('.leh-shopify').length) {
        leh_handleShopifyLinks();
    }

    // $('.currency-code-after').html(leh_var('cur').toUpperCase());
    
});

function leh_handleShopifyLinks() {
    $('a.leh-shopify').each(function () {
        let $link = $(this);
        let hasClick = $link.hasClass('leh-click');

        $link.removeAttr('data-hdp');
        $link.removeAttr('data-order');
        $link.removeClass('wordplugHdpOrderBridge wordplugHdpOrderButton');

        $link.off('click');

        $link.on('click', function (e) {
            e.preventDefault();

            let targetUrl = '/store/?link=' + encodeURIComponent($link.attr('data-link'));

            if (!hasClick) {
                targetUrl += '&nc=1';
            }

            window.location.href = targetUrl;
        });
    });
}

function toggleHdpSwitch() {
    if (leh_var('cc') == 'US'  && leh_var('cur') == 'usd') {
        $('.wordplugHdpToggle').removeClass('d-none');
        $('.package.qty-1').addClass('hdpWrap');
    } else {
        $('.wordplugHdpToggle').addClass('d-none');
        $('.package.qty-1').removeClass('hdpWrap');
        // $('#hdp-toggle-switch').prop('checked', false).change();
        roundPrices();
    }
}

function animateNumber($element, targetNumber, duration, easingFunction, initNumber = null, rounding = false, showCents = false) {
    if (!leh_var('cur') == 'usd') {
        roundPrices();
        return;
    }    

    let startNumber = parseFloat($element.attr('usdprice'));
    if (initNumber) {
        startNumber = parseFloat(initNumber);
    }

    let startTime = null;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        let progress    = timestamp - startTime;
        let percent     = Math.min(progress / duration, 1);
        percent         = easingFunction(percent);

        let currentNumber = startNumber + (targetNumber - startNumber) * percent;

        if (showCents) {
            currentNumber = currentNumber.toFixed(2);
        } else {
            currentNumber = Math.floor(currentNumber);
        }

        // add .attr('usdprice', currentNumber) if necessary
        $element.text('$' + currentNumber);

        if (progress < duration) {
            window.requestAnimationFrame(step);
        } else {
            if (showCents) {
                $element.text('$' + parseFloat(targetNumber).toFixed(2)); // Keep cents
            } else {
                $element.text('$' + Math.floor(targetNumber)); // Whole number
            }

            if (rounding) {
                roundPrices();
            }
        }
    }

    window.requestAnimationFrame(step);
}

function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function roundPrices() {
    let prices = $('[round]');
    $.each(prices, function(index, element) {
        let usdPrice = parseFloat($(element).attr('usdprice'));
        let roundedValue = Math.round(usdPrice / exchangeRate());
        let formattedValue = roundedValue.toFixed($(element).attr('round'));
        $(element).html(formatPriceValue(formattedValue, leh_var('cur'), null, $(element).attr('round'), $(element).attr('round')));
    });
}

function leh_call() {
    return new Promise(function(resolve) {
        if (_wordplug.callQs.length > 0) {
            _wordplug.callQs = _wordplug.callQs.substring(1);
        }
        jQuery.ajax({
            url: '/wp-json/wordplug/v2/check?' + (_wordplug.callQs ?? ''),
            type: 'GET',
            data: _wordplug.callData,
            traditional: true,
            success: function (result) {
                if (typeof window.afterCheck === 'object' && typeof window.afterCheck.immediate === 'function') {
                    window.afterCheck.immediate(result);
                }

                let promises = [];

                if (result.geo) {
                    promises.push(new Promise(resolve => {
                        leh_region(result.geo, resolve);
                    }));
                }
                if (result.tags) {
                    promises.push(new Promise(resolve => {
                        leh_tags(result.tags, resolve);
                    }));
                }
                if (result.pc) {
                    promises.push(new Promise(resolve => {
                        leh_pc(result.pc, resolve);
                    }));

                    if (result.pc.splashes) {
                        promises.push(new Promise(resolve => {
                            leh_handleMultiSplashes(result.pc.splashes, resolve);
                        }));
                    }
                }
                if (result.cpn) {
                    promises.push(new Promise(resolve => {
                        leh_showCouponSplash(result.cpn, resolve);
                    }));
                }
                
                if (result.fs) {
                    promises.push(new Promise(resolve => {
                        leh_showFreeShipping(result.fs, resolve);
                    }));
                }

                if (result.pp) {
                    promises.push(new Promise(resolve => {
                        leh_handlePP(result.pp, resolve);
                    }));
                }
                if (result.pprocs) {
                    promises.push(new Promise(resolve => {
                        leh_handlePProcs(result.pprocs, resolve);
                    }));
                }
                if (result.cart) {
                    _wordplug.cart = result.cart;
                }
                if (result.curr) {
                    _wordplug.curr = result.curr;
                    updateOrderLinks(result.curr.sel);
                    priceConverter(result.curr.sel);
                }

                Promise.all(promises).then(() => {
                    _wordplug.called = true;

                    if (typeof window.afterCheck === 'object' && typeof window.afterCheck.postCheck === 'function') {
                        window.afterCheck.postCheck(result);
                    }

                    resolve();
                });
            }
        });
    });
}

function leh_handlePProcs(pprocs, resolve) {
    for (const [processor, isAvailable] of Object.entries(pprocs)) {
        const className = `.pproc-${processor}`;

        if (isAvailable) {
            $(className).removeClass('d-none');
        } else {
            $(className).addClass('d-none');
        }
    }

    resolve();
}

function leh_handlePP(pp, resolve) {
    if (pp.all_valid) {
        $('.ccards-paypal').removeClass('d-none');
    } else {
        $('.ccards-paypal').addClass('d-none');
    }

    resolve();
}

function leh_showFreeShipping(fs, resolve) {
    setTimeout(function() {
        $('.shipping-banner').removeClass('d-none');
        if (fs.all) {
            $('.shipping-all').removeClass('d-none');
        }
        if (fs.usaonly) {
            $('.shipping-usaonly').removeClass('d-none');
        }
    }, 500);
    

    resolve();
}

function leh_handleMultiSplashes(splashes, resolve) {
    splashes.forEach(function(splash) {
        // Check and insert splash_html into splash_target.
        if (splash.splash_target) {
            var $target = $(splash.splash_target);
            if ($target.length) {
                $target.html(splash.splash_html);

                // Hide target (only if splash_target found).
                if (splash.hide_target) {
                    var $hideTarget = $(splash.hide_target);
                    if ($hideTarget.length) {
                        $hideTarget.hide();
                    }
                }
            }
        }
    });

    resolve();
}

// Search for any coupon splash elements and render content within.
function leh_showCouponSplash(cpn, resolve) {
    if (cpn && cpn.splash) {
        var elements = document.querySelectorAll('.couponSplash');
        
        elements.forEach(function(element) {
            element.innerHTML = cpn.splash;
        });
    }
    resolve();
}

function leh_updateCallQs(key, value) {
    if (!_wordplug.callQs) {
        _wordplug.callQs = '';
    }

    _wordplug.callQs += '&' + key + '=' + encodeURIComponent(value);
}

// Dig through products passed from a promo check and see if any have a 'promo'
// discount in any line items within. ie. "discount": "promo"
function checkProductsForPromoDiscount(productsObject) {
    const productDiscountStatus = {};

    function searchForPromo(obj) {
        if (typeof obj === 'object' && obj !== null) {
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];

                    // Check for the specific 'discount' key
                    if (key === 'discount' && value === 'promo') {
                        return true; // Found the 'promo' discount
                    }
                    // Dig deeper...
                    if (typeof value === 'object' && value !== null) {
                        if (searchForPromo(value)) {
                            return true;
                        }
                    }
                }
            }
        }
        
        // 'promo' not found in this branch
        return false; 
    }

    for (const productKey in productsObject) {
        if (productsObject.hasOwnProperty(productKey)) {
            const productData = productsObject[productKey];

            // Run the search and store the result
            productDiscountStatus[productKey] = searchForPromo(productData);
        }
    }

    return productDiscountStatus;
}

function leh_pc(pc, resolve) {
    _wordplug.pc = pc;
    if (pc.qual) {
        pcQual = true;
    }

    if (pcQual && pc.product_splashes && Object.keys(pc.product_splashes).length > 0) {
        let splashes = pc.product_splashes;
        let promoResults = checkProductsForPromoDiscount(pc.products)
        let allValues = Object.values(splashes);
        let firstSplash = allValues[0];

        if (firstSplash && Object.values(promoResults).every(result => result === true)) {
            $('.sale-message, #promo-splash').empty().html(firstSplash);
            $('.sale-message, #promo-splash').removeClass('d-none');
        }
    } else {
        $('.sale-message, #promo-splash').addClass('d-none');
    }

    // Handle modal.
    if ((pc.modal && window.location.pathname == '/') || $('#showPromoModal').length > 0) {
        $('#content').prepend(pc.content);
        if ($('#dsPopup').length && !pcTriggered) {
            $('#dsPopup').modal('show');
            pcTriggered = true;
        }
    }

    // Handle banner.
    if (pc.banner) {
        $('.promo-banner').prepend(pc.content).show();
        $('.default-banner').hide();
    }
    if (pc.alt_banner && $('.alt-promo-banner').length > 0) {
        $('.alt-promo-banner').prepend(pc.alt_content).show();
        $('.alt-banner, .default-banner').hide();
    }
    // Handle Sezzle.
    if (pc.allowSezzle) {
        jQuery.each($('.sezzle-usd'), function () {
            let price = $(this).attr('usd-price');
            $(this).text(formatPriceValue(price / exchangeRate(), leh_var('cur')));
        });
        $('.sezzle-object').show();
    } else {
        $('.sezzle-object').hide();
    }

    if (pc.products && pcQual) {
        products = pc.products;

        // If an element contains the following attribute:
        // showpriceperunit='true' then we will show the price per unit when
        // the price is displayed after the promo price is pulled.
        let showPricePerUnit = false;
        $(Object.keys(pc.products)).each(function (key, val) {
            let pref = val;
            let buttons = $('[pref="' + val + '"][qty]');
            if (buttons.length) {
                buttons.each(function (key, obj) {
                    let qty = $(obj).attr('qty');
                    if (products[pref][qty].length > 1) {
                        $(products[pref][qty]).each(function (item) {
                            // gross_price = 0 + Number(this.gross_price);
                            // price = 0 + Number(this.price_discounted);
                            let attached = products[pref][qty].length;
                            if (pc.qual && this.discount == "promo" && (attached > 1)) {
                                let bogoUnits = products[pref][qty][1].qty;
                                $(obj).text("Buy " + qty + ", Get " + bogoUnits + " Free!");
                            }
                            
                        });
                    } else {
                        $(obj).attr('price', products[pref][qty][0].price_discounted);
                    }
                    
                    $(products[pref][qty]).each(function (item) {
                        let gross_price = 0 + Number(this.gross_price);
                        let price = 0 + Number(this.price_discounted);
                        if (pc.type == 'retail') {
                            $(obj).attr('price_gross', pc.products[pref][qty][0].price);
                            $(obj).attr('price', pc.products[pref][qty][0].price_discounted);
                            $('.retail-label').text('Retail');
                        } else {
                            $(obj).attr('price_gross', pc.products[pref][qty][0].gross_price);
                            $(obj).attr('price', pc.products[pref][qty][0].price_discounted);
                        }
                    });
                });
            }

            // Checkout Site:
            if ($('.package').length > 0) {
                // Retail Prices.
                $('.leh_retail').each(function (key, val) {
                    showPricePerUnit = $(val).attr('showpriceperunit') ? true : false;
                    if (showPricePerUnit) {
                        $(val).attr('usdprice', products[pref][$(val).attr('qty')][0].gross_price/$(val).attr('qty'));
                    } else {
                        $(val).attr('usdprice', products[pref][$(val).attr('qty')][0].gross_price);
                    }
                    
                    $(val).text(formatPriceValue(
                            ($(this).attr('usdprice') / exchangeRate()),
                            leh_var('cur')
                        )
                    );
                });

                // Prices.
                $('.leh_price').each(function (key, val) {
                    showPricePerUnit = $(val).attr('showpriceperunit') ? true : false;
                    if (pcQual) {
                        if (showPricePerUnit) {
                            $(val).attr('usdprice', products[pref][$(val).attr('qty')][0].price_discounted/$(val).attr('qty'));
                        } else {
                            $(val).attr('usdprice', products[pref][$(val).attr('qty')][0].price_discounted);
                        }
                    } else {
                        if (showPricePerUnit) {
                            $(val).attr('usdprice', products[pref][$(val).attr('qty')][0].price/$(val).attr('qty'));
                        } else {
                            $(val).attr('usdprice', products[pref][$(val).attr('qty')][0].price);
                        }
                    }
                    
                    $(val).text(formatPriceValue(($(this).attr('usdprice') / exchangeRate()), leh_var('cur')));
                });

                // Savings.
                $('.leh_price').each(function (key, val) {
                    showPricePerUnit = $(val).attr('showpriceperunit') ? true : false;
                    
                    let q = $(val).attr('qty');
                    let price = $('.leh_price[qty="' + q + '"]').attr('usdprice');
                    let retail = $('.leh_retail[qty="' + q + '"]').attr('usdprice');
                    let savings = formatPriceValue(((retail - price) / exchangeRate()), leh_var('cur'));
                    
                    if (showPricePerUnit) {
                        $('.leh_savings[qty="' + q + '"]').attr('usdprice', ((retail - price)/q));
                        $('.leh_savings[qty="' + q + '"]').text(savings/q);
                    } else {
                        $('.leh_savings[qty="' + q + '"]').attr('usdprice', (retail - price));
                        $('.leh_savings[qty="' + q + '"]').text(savings);
                    }
                });
            }

            if (typeof update_cart_button === "function" && $('.package').length == 0) {
                let focusedQty = $('.lehproduct:focus').attr('qty') ?? 1;
                update_cart_button(focusedQty);
            }
        });

    }
    resolve();
}

function leh_tags(tags, resolve) {
    _wordplug.tags = tags;
    tags.forEach(tracker => {
        if (tracker.script) {
            let networkScript = document.createElement('script');
            networkScript.setAttribute('src', tracker.script);
            networkScript.setAttribute('data-type', tracker.network);
            document.body.appendChild(networkScript);
        }
        if (tracker.payload) {
            eval(tracker.payload);
        }
    });
    resolve();
}

function leh_region(geo, resolve) {
    _wordplug.countryCode = geo;
    if (geo) {
        leh_set('cc', geo.cc, true);
    }
    if (geo.region) {
        leh_set('region', geo.region);
    }
    if (geo.cur) {
        priceConverter(geo.cur);
        let $elements = $('.currency-selector, .currencySelect');
        if ($elements.length > 0) {
            $elements.val(geo.cur);
        }
        updatePrices();
    }

    leh_setGeoIpPhone(geo.region);
    resolve();
}

function leh_updateGeoIpPhoneNumbers() {
    if (typeof phoneNumbers === 'undefined' || phoneNumbers === null) return;
    if (!phoneNumbers) return;

    if (leh_var('region')) {
        leh_setGeoIpPhone(leh_var('region'));
    } else {
        // _wordplug.checkCountry = true;
        // leh_updateCallQs('countryCheck', '1');
    }
}

function leh_setGeoIpPhone(region) {
    let phoneNumberInfo = phoneNumbers[region];

    $('.geoipPhoneLabel').html(phoneNumberInfo.label);
    $('.geoipPhoneNumber').html(phoneNumberInfo.phone);
    $('.geoipPhoneNumber').attr('href', 'tel:' + phoneNumberInfo.phone);
}

function leh_updateCartIcon() {
    let itemCount = leh_var('cart_lines');
    let itemIcon  = document.querySelector('#cartIcon > .itemCount');
    if (itemCount > 0 && itemIcon) {
        itemIcon.innerHTML = itemCount;
        if (itemCount < 1) {
            itemIcon.style.display = 'none';
        } else {
            itemIcon.style.display = 'block';
        }
    }
}

function leh_setupCartIcon() {
    let cartIcon = document.getElementById('cartIcon');
    let count = leh_var('cart_lines');
    if (cartIcon) {
        let itemCount = document.createElement('div');
        itemCount.className = "itemCount";
        cartIcon.appendChild(itemCount);

        leh_updateCartIcon(count);
    }
}

function leh_setupPromoCode() {
    var u = leh_var('u');
    if (u != null) {
        $('.prc').each(function () {
            this.innerHTML = this.innerHTML.replace('None', u);
        });
    }
}

function updateOrderLinks(cur) {
    var packageList = document.getElementsByClassName('package');
    if (packageList) {
        for(var i=0;i<packageList.length;i++) {
            var buttonList = packageList[i].getElementsByClassName('button');
            if (buttonList && buttonList.length == 1) {
                var bLink = buttonList[0];
                if (bLink) {
                    if (bLink.href.indexOf('cur') === -1) {
                        var href = bLink.href+'&cur='+cur;
                    } else {
                        var href = bLink.href.replace(/([\&\?])cur=[a-zA-Z]{3}/, '$1cur='+cur.toLowerCase());
                    }
                    bLink.href = href;
                }
            }
        }

        $('.currency-selector, .currencySelect').val(cur.toUpperCase());
        priceConverter(cur.toUpperCase());
    }
}

/**
 * Check only the sezzle status for this user.
 */
function checkSezzle() {
    if ($('.sezzle-usd').length || $('.sezzle-object').length) {
        jQuery.ajax({
            url: '/wp-json/wordplug/v2/sezzle',
            type: 'GET',
            success: function (result) {
                if (result) {
                    if (result.allowSezzle) {
                        jQuery.each($('.sezzle-usd'), function () {
                            let price = $(this).attr('usd-price');
                            $(this).text(formatPriceValue(price / exchangeRate(), leh_var('cur')));
                        });
                        $('.sezzle-object').show();
                    } else {
                        $('.sezzle-object').hide();
                    }
                }
            },
        });
    }
}

// Handle promo-checking on product pages.
let products = [];
let pcQual = false;
let pcTriggered = false;
function leh_prep() {
    let prefs   = [];
    let pBan    = 0;
    let items   = $('[class*="lehproduct"]');
    let altOid  = $('#alt-oid').attr('oid');
    
    if (altOid) {
        altOid = '?oid=' + altOid;
        leh_updateCallQs('oid', altOid);
    } else {
        altOid = '';
    }

    $(items).each(function () {
        let pref = $(this).attr('pref');
        if (prefs.indexOf(pref) == -1 && pref != '' && pref != null) {
            prefs.push(pref);
        }
    });

    if ($('.promo-banner').length || window.location.pathname == '/' || $('.alt-promo-banner').length) {
        pBan = 1;
    }

    // TODO: If later requirements of multiple prefs arise.
    // if (prefs.length) {
    //     if (prefs.length === 1) {
    //         _wordplug.callData['prefs'] = prefs[0];
    //     } else {
    //         _wordplug.callData['prefs'] = prefs;
    //     }
    // }
    if (prefs.length) {
        _wordplug.callData['prefs'] = prefs;
    }
    _wordplug.callData['bc']= pBan;
    leh_updateCallQs('pc', '1');
}

/**
 * Get the variable from the cookie
 *
 * @param string varname without the
 * @param {*} def Not sure what this is used for
 *
 * @return mixed cookie value or null
 */
function leh_var(varname, def) {
    varname = 'leh_' + varname;
    if (Cookies.get(varname)) {
        return Cookies.get(varname);
    }
    if (typeof (def) !== "undefined") {
        return def;
    }

    return null;
}

/**
 * Return the exchange rate for the current set currency.
 *
 * @return int exchange rate.
 */
function exchangeRate(cur) {
    let curList = leh_get_currency_list();

    if (!curList) {
        return 1;
    }

    let currency = jQuery.grep(curList, function (e) { return e.currency == leh_var('cur'); });
    
    if (cur) {
        currency = jQuery.grep(curList, function (e) { return e.currency == cur.toLowerCase() });
        return currency[0].exchange_rate;
    }
    if (currency.length > 0) {
        if (currency[0].currency == leh_base_cur) {
            return 1;
        }

        return currency[0].exchange_rate;
    } else {
        return 1;
    }
}

/**
 * Set the cookie variable
 *
 * @param string varname Variable Name
 * @param {*} value
 *
 * @return void
 */
function leh_set(varname, value, upperCase = false) {
    varname = 'leh_' + varname;
    if (upperCase) {
        value = value.toUpperCase();
    } else {
        value = value.toLowerCase();
    }

    Cookies.set(varname, value, { expires: FIVE_YEARS_IN_DAYS, secure: true });
}

/**
 * Gets the list of currencies
 *
 * @return list of currencies
 */
function leh_get_currency_list() {
    return JSON.parse(decodeURIComponent(leh_var('currencies')));
}

/**
 * Validates the email address calling to the restfull api
 *
 * @param {*} callback Calls callback function to return the JSON
 *
 */
function leh_validate_email(email_address, callback) {
    leh_api_request('/address/validate/' + email_address, 'GET', callback);
}

/**
 * An ajax post to update the quantity
 *
 * @param {*} select The dom element on change for the select list
 * @param {*} callback Calls callback function to return the JSON
 *
 * @return void
 */
function leh_update_quantity(cart_ref, qty, callback) {
    leh_request('/v2/cart/update/' + cart_ref + '/' + qty, 'POST', callback);
}

/**
 * Calls off to the ajax function to remove the cart item
 *
 * @param {*} cart_ref
 * @param {*} callback Calls callback function to return the JSON
 *
 */
function leh_remove_product(cart_ref, callback) {
    leh_request('/v2/cart/remove/' + cart_ref, 'DELETE', callback);

    leh_call();
}

/**
 * An ajax post to add an item
 *
 * @param {*} cart_ref The item reference for the cart
 * @param {*} qty      The Quantity to add
 * @param {*} callback Calls callback function to return the JSON
 *
 * @return void
 */
function leh_add_to_cart(cart_ref, qty, callback) {
    leh_api_request('/cart/add/' + cart_ref + '/' + qty, 'POST', callback);
}

/**
 * Calls off to the ajax function to remove the cart item
 *
 * @param {*} callback Calls callback function to return the JSON
 *
 */
function leh_remove_coupon(callback) {
    leh_api_request('/cart/cpn/remove', 'DELETE', function () {
        leh_api_request('/cart', 'GET', callback);
    });
}

/**
 * Calls off to the ajax function to get the current cart json
 *
 * @param {*} callback Calls callback function to return the JSON
 *
 */
function leh_get_cart(callback) {
    leh_request('/v2/promo/cart', 'GET', callback);
}

/**
 * Calls off to the ajax function to do api operations
 *
 * @param {*} params   Operation parameters to add to the request URL
 * @param {*} type     Request type
 * @param {*} callback Calls callback function to return the JSON
 *
 */
function leh_api_request(params, type, callback) {
    jQuery.ajax({
        url: '/wp-json/wordplug/v2' + params,
        type: type,
        success: function (result) {
            callback((result));
        },
        fail: function (result) {
            callback({ fail: true, result: result });
        }
    });
}

/**
 * POST an array of English phrases to have translated to the language
 * associated with the passed Country Code.
 *
 * @param {*} phrases   Array of phrases to translate
 * @param {*} cc        Two letter country code to translate to
 * @param {*} callback  Calls callback function to return the JSON
 *
 */
function leh_translate(phrases, cc, callback) {
    jQuery.ajax({
        url: '/wp-json/wordplug/v2/translate',
        type: 'POST',
        data: {
            lang: cc,
            phrases: phrases,
        },
        success: function (result) {
            callback(result);
        },
        fail: function (result) {
            callback({ fail: true, result: result });
        }
    });
}

/**
 * Calls off to the ajax function to do api operations against the
 * v2 api.
 *
 * @param {*} params   Operation parameters to add to the request URL
 * @param {*} type     Request type
 * @param {*} callback Calls callback function to return the JSON
 *
 */
function leh_request(params, type, callback) {
    if (params.substring(0, 1) != '/') {
        params = '/' + params;
    }

    jQuery.ajax({
        url: '/wp-json/wordplug' + params,
        type: type,
        success: function (result) {
            callback(result);
            updateOrderLinks(result.cur);
            priceConverter(result.cur);
        },
        fail: function (result) {
            callback({ fail: true, result: result });
        }
    });
}

/**
 * Check a remote site for a uid.
 *
 * @param {*} fp        Unique user print
 * @param {*} host      Host URL to check against (source-website)
 * @param {*} callback  Calls callback function to return the JSON
 *
 */
function leh_hostCheck(fp, host, callback) {
    jQuery.ajax({
        url: '/wp-json/wordplug/v2/usearch?fp=' + fp + '&ws=' + host,
        type: 'GET',
        success: function (result) {
            callback(result);
        },
        error: function (result) {
            callback({
                fail: true,
                result: null
            });
        }
    });
}

function priceConverter(newCurr) {
    if (newCurr) {
        leh_set('cur', newCurr);
    }
    let conversions = $('[class*="lehprod"]:not(.qty-btn)');

    $.each(conversions, function () {
        $(this).html(formatPriceValue(
            ($(this).attr('usdprice') / exchangeRate()),
            leh_var('cur')
        ));
    });
    roundPrices();
}


function formatPriceValue(value, currency, total, minFractionDigits, maxFractionDigits) {
    const formatOptions = {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: minFractionDigits || 2,
        maximumFractionDigits: maxFractionDigits || 2
    };
    
    switch (currency) {
        case 'gbp':
            $('.currency-message').text('Prices shown in GBP');
            return Intl.NumberFormat('en-GB', { ...formatOptions, currency: 'GBP' }).format(value);
        case 'eur':
            $('.currency-message').text('Prices shown in EUR');
            return Intl.NumberFormat('de-DE', { ...formatOptions, currency: 'EUR' }).format(value);
        case 'cad':
            $('.currency-message').text('Prices shown in CAD');
            return Intl.NumberFormat('en-CA', { ...formatOptions, currency: 'CAD' }).format(value);
        case 'aud':
            $('.currency-message').text('Prices shown in AUD');
            return Intl.NumberFormat('en-AU', { ...formatOptions, currency: 'AUD' }).format(value);
        case 'usd':
        default:
            $('.currency-message').text('Prices shown in USD');
            return Intl.NumberFormat('en-US', { ...formatOptions, currency: 'USD' }).format(value);
    }
}

/* * Google Shopping setup
    * Check the referrer and update the referrer cookie if it is
    * not already set. If coming in with a ?uid=12345
    * then update the cookie with the uid.
    * 
    * @param {string} targetUid The target UID to update the cookie with.
    * @param {string} referrer The referrer to update the cookie with.
    * @return null
* */
function googleShop() {
    let match = window.location.href.match(/\?(\d+)/);
    if (match) {
        let targetUid = match[1];

        // Skip fp logic, go straight to update
        if (!leh_first_click || leh_var('u') == null) {
            updateUid(targetUid);
        }

    } else if ("" + document.referrer !== "" && !Cookies.get("leh_u")) {
        // if the referrer is blank do not update the referrer
        // if there is a ct user then do not update the referrer
        leh_api_request('/referrer/' + encodeURI(document.referrer), 'GET', function (result) {
            if (result && result.ref) {
                Cookies.set('leh_ref', result.ref, { expires: FIVE_YEARS_IN_DAYS, secure: true });
            }
        });
    }
}

function updateUid(targetUid) {
    Cookies.set('leh_u', targetUid);
    Cookies.remove('leh_ref');
    Cookies.remove('leh_t');
    Cookies.remove('leh_t1');
    Cookies.remove('leh_t2');
    Cookies.remove('leh_t3');
    Cookies.remove('leh_t4');
    Cookies.remove('leh_t5');
    Cookies.remove('leh_b');
    Cookies.remove('leh_c');
    Cookies.remove('leh_a');
    Cookies.remove('leh_r');
    Cookies.remove('leh_src');
    Cookies.remove('leh_lid');
    Cookies.remove('leh_pool_id');
    Cookies.remove('leh_ncr');
    Cookies.remove('leh_acv');
    Cookies.remove('leh_ct');

    let rap = leh_var('rap');

    // Add leh_u var to the top of an rap existing array. Shift others down.
    if (rap) {
        rap = rap.split(':');
        rap.unshift(targetUid);
        if (rap.length > 5) {
            rap.length = 5;
        }
        rap = rap.join(':');

        // Set the newly formed array back into leh_rap.
        leh_set('rap', rap);
    } else {
        // If no rap is present, add the singular value.
        leh_set('rap', targetUid);
    }

}

function getScript(source, callback) {
    var script = document.createElement('script');
    var prior = document.getElementsByTagName('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = function (_, isAbort) {
        if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
            script.onload = script.onreadystatechange = null;
            script = undefined;

            if (!isAbort && callback) setTimeout(callback, 0);
        }
    };

    script.src = source;
    prior.parentNode.insertBefore(script, prior);
}


document.addEventListener('DOMContentLoaded', function () {
    $('a.wordplugOrderBridge').unbind('click').bind('click', function(e) {
        e.preventDefault();
        orderBridge(this);
    });
    
    $('a.wordplugHdpOrderBridge').unbind('click').bind('click', function(e) {
        e.preventDefault();
        $(document).on('click', 'a.wordplugHdpOrderBridge', function (e) {
            let cc  = leh_var('cc') ?? '';
            let cur = leh_var('cur') ?? '';
            let hdp = $('#wordplugHdpPopup');
            let hdpUnchecked = false;

            $('.hdp-toggle-switch').each(function() {
                if ($(this).attr('aria-pressed') === 'true') {
                    hdpUnchecked = true;
                    return false;
                }
            });

            if (hdp.length && cc == 'US' && cur == 'usd' && !hdpUnchecked) {
                $('.wordplugHdp-signup, .wordplugHdp-nothanks').on('click', handleLinkClick);
                hdp.on('hidden.bs.modal', function (e) {
                    $('.wordplugHdp-nothanks').click();
                });
                hdp.modal('show');
            } else {
                orderBridge($(this).attr('href'));
            }
        });
    });
});

function handleLinkClick(e, href) {
    e.preventDefault();
    if ($(this).attr('href')) {
        let link = new URL($(this).attr('href'));
        let searchParams = new URLSearchParams(link.search);
        let targetlink = buildTargetLink(link, searchParams);

        window.location.href = targetlink;
    }

}

function buildTargetLink(link, searchParams) {
    let params = '';
    let targetlink = '/checkout/?oid=' + link.pathname.replaceAll('/', '');

    if (searchParams) {
        for (var [key, value] of searchParams.entries()) {
            params += '&' + key + '=' + value;
        }
        targetlink += params;
    }

    return targetlink;
}

// Handle order bridging in non-HDP situations.
function orderBridge(e) {
    let href 	= e;
    let link 	= new URL(href);
    let params 	= new URLSearchParams(link.search);
    let target 	= buildTargetLink(link, params);
    
    window.location = target;

    return '';
}

function translate() {
    let langCode = document.getElementsByTagName('html')[0].getAttribute('lang');

    if (!langCode) {
        return;
    }

    langCode = langCode.slice(0, 2);
    let phrases = document.getElementsByClassName('translate');
    let toTranslate = [];

    if (phrases.length > 0 && langCode != 'en') {
        for (const phrase of phrases) {
            toTranslate.push(phrase.innerHTML);
        }

        leh_translate(toTranslate, langCode, function(result) {
            if (result) {
                for (const phrase of phrases) {
                    for (const translated of result) {
                        if (translated) {
                            if (phrase.innerHTML == translated.phrase.phrase) {
                                phrase.innerHTML = translated.translation;
                            }
                        }
                    }
                }
            }
        });
    }
}
